module.exports = __webpack_public_path__ + "4413fb6c28abe72caf9b3e1e56812855.jpg";